import { useNavigate, useParams } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card } from '../components/ui/card';
import { UserX, Search, Home, ArrowLeft } from 'lucide-react';

export default function UserNotFoundPage() {
  const navigate = useNavigate();
  const { handle } = useParams();

  // Log the 404 for audit purposes
  console.warn('[UserNotFound] Profile not found for identifier:', handle);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <Card className="max-w-md w-full p-8 text-center space-y-6 bg-card border-border">
        {/* Icon */}
        <div className="w-20 h-20 mx-auto rounded-full bg-muted/30 flex items-center justify-center">
          <UserX className="w-10 h-10 text-muted-foreground" />
        </div>

        {/* Title */}
        <div>
          <h1 className="text-2xl font-bold mb-2">User Not Found</h1>
          <p className="text-muted-foreground">
            {handle ? (
              <>The profile <span className="text-white font-mono">@{handle}</span> doesn't exist or has been removed.</>
            ) : (
              <>This profile doesn't exist or has been removed.</>
            )}
          </p>
        </div>

        {/* Suggestions */}
        <div className="text-sm text-muted-foreground space-y-2">
          <p>This could happen if:</p>
          <ul className="list-disc list-inside text-left space-y-1">
            <li>The username was typed incorrectly</li>
            <li>The user changed their handle</li>
            <li>The account was deleted or suspended</li>
          </ul>
        </div>

        {/* Actions */}
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Button 
            variant="outline" 
            onClick={() => navigate(-1)}
            className="gap-2"
          >
            <ArrowLeft className="w-4 h-4" />
            Go Back
          </Button>
          <Button 
            variant="outline"
            onClick={() => navigate('/discover')}
            className="gap-2"
          >
            <Search className="w-4 h-4" />
            Discover Artists
          </Button>
          <Button 
            onClick={() => navigate('/')}
            className="gap-2"
          >
            <Home className="w-4 h-4" />
            Home
          </Button>
        </div>

        {/* Support link */}
        <p className="text-xs text-muted-foreground">
          Think this is a mistake?{' '}
          <a href="mailto:support@dmvsoundstage.com" className="text-secondary hover:underline">
            Contact Support
          </a>
        </p>
      </Card>
    </div>
  );
}
